<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>特种设备安全监察条例（２００９年修订）</h1>
        <div class="first">
          <p>（２００３年３月１１日中华人民共和国国务院令第３７３号公布根据２００９年１月２４日《国务院关于修改〈特种设备安全监察条例〉的决定》修订）</p>
          <P>第一章 总 则</P>
        </div>
        <div class="date">发布时间：2020-5-20&nbsp13:30</div>
        <div class="xh"></div>

        <div class="second">
          <p>第一条 为了加强特种设备的安全监察，防止和减少事故，保障人民群众生命和财产安全，促进经济发展，制定本条例。</p>
          <p>第二条 本条例所称特种设备是指涉及生命安全、危险性较大的锅炉、压力容器（含气瓶，下同）、压力管道、电梯、起重机械、客运索道、大型游乐设施和场（厂）内专用机动车辆。</p>

          <p>第三条 特种设备的生产（含设计、制造、安装、改造、维修，下同）、使用、检验检测及其监督检查，应当遵守本条例，但本条例另有规定的除外。</p>

          <p>军事装备、核设施、航空航天器、铁路机车、海上设施和船舶以及矿山井下使用的特种设备、民用机场专用设备的安全监察不适用本条例。</p>

          <p>房屋建筑工地和市政工程工地用起重机械、场（厂）内专用机动车辆的安装、使用的监督管理，由建设行政主管部门依照有关法律、法规的规定执行。</p>

          <p>第四条 国务院特种设备安全监督管理部门负责全国特种设备的安全监察工作，县以上地方负责特种设备安全监督管理的部门对本行政区域内特种设备实施安全监察（以下统称特种设备安全监督管理部门）。</p>

          <p>第五条 特种设备生产、使用单位应当建立健全特种设备安全、节能管理制度和岗位安全、节能责任制度。</p>
          <p>特种设备生产、使用单位的主要负责人应当对本单位特种设备的安全和节能全面负责。</p>

          <p>特种设备生产、使用单位和特种设备检验检测机构，应当接受特种设备安全监督管理部门依法进行的特种设备安全监察。</p>

          <p>第六条 特种设备检验检测机构，应当依照本条例规定，进行检验检测工作，对其检验检测结果、鉴定结论承担法律责任。</p>

          <p>第七条 县级以上地方人民政府应当督促、支持特种设备安全监督管理部门依法履行安全监察职责，对特种设备安全监察中存在的重大问题及时予以协调、解决。</p>

          <p>第八条 国家鼓励推行科学的管理方法，采用先进技术，提高特种设备安全性能和管理水平，增强特种设备生产、使用单位防范事故的能力，对取得显著成绩的单位和个人，给予奖励。</p>

          <p>国家鼓励特种设备节能技术的研究、开发、示范和推广，促进特种设备节能技术创新和应用。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
    GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
  }
};
</script>
<style lang="less" scoped>
.date{
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 28px;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p {
  font-weight: 600;
}
</style>